document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion)');
  const counters = [...document.querySelectorAll('.counter')];
  const circles = [...document.querySelectorAll('.circle-counter')];

  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const counter = entry.target;
        const before = counter.getAttribute('data-before');
        let value = counter.getAttribute('data-value') * 1;
        const after = counter.getAttribute('data-after');

        if (value != '') {
          value = value * 1;
        }
        let maxIterations = 20;

        if (reduceMotion.matches) {
          maxIterations = 1;
        }
        const intervalDuration = 50;
        const step = value / maxIterations;
        let iterations = 0;
        const timer = setInterval(() => {
          iterations++;
          if (iterations <= maxIterations) {
            counter.textContent = formatNumber(
              before,
              step * iterations,
              after
            );
          } else {
            clearInterval(timer);
            if (value != '')
              counter.textContent = formatNumber(before, value, after);
          }
        }, intervalDuration);
      }
    });
  });

  counters.forEach((counter) => {
    const before = counter.getAttribute('data-before');
    const after = counter.getAttribute('data-after');
    const value = counter.getAttribute('data-value');
    if (value != '') {
      counter.textContent = formatNumber(before, 0, after);
      counterObserver.observe(counter);
    }
  });

  const circleObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.intersectionRatio > 0) {
        const counter = entry.target;
        const value = counter.getAttribute('data-value');
        const svg = counter.querySelector('svg');
        svg.style.animation = `1s ease-out  ${
          index * 0.3 + 1
        }s 1 forwards animatepercentage-${value} `;
      }
    });
  });

  circles.forEach((counter) => {
    const value = counter.getAttribute('data-value');
    if (value != '') {
      circleObserver.observe(counter);
    }
  });

  function formatNumber(before, value, after) {
    return `${before}${parseInt(value).toLocaleString('en', {
      useGrouping: true,
    })}${after}`;
  }
});
